import { Camada, CamadaTiff } from './camada.types';
import { UsuarioProjeto } from './usuario.types';

export enum TIPO_PROJETO {
  ICAD = 'ICAD',
  ICAD2 = 'ICAD2',
  ICAD_DEFAULT = 'ICADPADRAO',
  WEBGEO = 'WEBGEO',
  PVGEO = 'PVGEO',
  OUV = 'OUV',
  ZONEAMENTO = 'ZONEAMENTO',
}

export const PVG_PORTAL_KEY = 'ovi';
export const GENERIC_PORTAL_KEY = 'simples';
export interface Projeto {
  id: number;
  nome: string;
  alias?: string;
  tipoProjeto: keyof typeof TIPO_PROJETO;
  cidade: string;
  configuracao?: string;
  usuario: UsuarioProjeto;
  ativo: boolean;
  projetosCamadas: Camada[];
  importacoesDxf: Camada[];
  importacoesTiff: CamadaTiff[];
  importacoesWms: Camada[];
  qtdCamadas: number;
  qtdGeometrias: number;
}
